import { useEffect, useState } from "react";
import { joiResolver, useForm } from "@mantine/form";
import { BusinessTypes } from "../../../enums/business-type";
import SoleProprietorForm from "./business-form-types/sole-proprietor-form.component";
import CorporationForm from "./business-form-types/corporation-form.component";
import BusinessStarterForm from "./business-form-types/business-starter-form.component";
import PartnershipForm from "./business-form-types/partnership-form.component";
import { BusinessFormSchema } from "../../../schemas/business-form.schema";
import { UseFormReturnType } from "@mantine/form/lib/use-form";
import { MerchantOnboardingFormValues } from "../../../type/merchant-onboarding-form-values.types";

interface BusinessFormStepProps {
  mainForm: UseFormReturnType<MerchantOnboardingFormValues>;
  active: number;
  activated: boolean;
  nextStep: () => void;
  prevStep: () => void;
}
function BusinessFormStep(props: BusinessFormStepProps) {
  const { mainForm, active, activated, nextStep, prevStep } = props;

  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: mainForm.values,
    schema: joiResolver(BusinessFormSchema),
  });

  useEffect(() => {
    if (!activated) {
      return;
    }
    form.setValues(mainForm.values);
  }, [active]);

  return (
    <>
      {!loading && mainForm.values.businessTypeId === BusinessTypes.STARTER && (
        <BusinessStarterForm
          mainForm={mainForm}
          form={form}
          active={active}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}
      {!loading &&
        mainForm.values.businessTypeId === BusinessTypes.SOLE_PROPRIETOR && (
          <SoleProprietorForm
            mainForm={mainForm}
            form={form}
            active={active}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        )}
      {!loading &&
        mainForm.values.businessTypeId === BusinessTypes.PARTNERSHIP && (
          <PartnershipForm
            mainForm={mainForm}
            form={form}
            active={active}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        )}
      {!loading &&
        mainForm.values.businessTypeId === BusinessTypes.CORPORATION && (
          <CorporationForm
            mainForm={mainForm}
            form={form}
            active={active}
            nextStep={nextStep}
            prevStep={prevStep}
          />
        )}
    </>
  );
}

export default BusinessFormStep;
